import { useState } from 'react';
import { BadgeCheck, ChevronUp } from 'lucide-react';
import { StatusPill } from '@/components/live';
import { useRows } from '@/hooks/useResource';
import { NameVerificationPanel, type NameVerificationRow } from '@/components/NameVerificationPanel';

/**
 * The latest name verification (0077) for a KYC record or land document. While it is open, "Verify
 * name" opens its proof and decision right here (owner, 2026-09-27: "add button for name
 * verification is pending?"; the Name verifications page was dropped the same day).
 */
export function NameVerificationLine({ entityTable, entityId }: { entityTable: 'party.party_kyc_records' | 'ops.plot_land_documents'; entityId: string }) {
  const [open, setOpen] = useState(false);
  const rows = useRows<NameVerificationRow>('name_verifications', {
    filters: { entity_table: entityTable, entity_id: entityId },
    orderBy: { column: 'created_at', ascending: false },
  });
  const latest = rows.data?.[0];
  if (!latest) return null;
  return (
    <>
      <span className="name-verification-line">
        <span>{latest.verification_code ?? 'Name verification'}</span> <StatusPill value={latest.verification_status} />
        {latest.verification_status === 'open' && (
          <button className="button-link" onClick={() => setOpen((now) => !now)} type="button">
            {open ? <><ChevronUp size={14} /> Close</> : <><BadgeCheck size={14} /> Verify name</>}
          </button>
        )}
      </span>
      {open && (
        <div className="name-check">
          <NameVerificationPanel onDone={() => setOpen(false)} row={latest} />
        </div>
      )}
    </>
  );
}
